module.exports = __webpack_public_path__ + "static/invoice-aadf252b30e20c6429c7b345531aed86.svg";